// @flow
import React from 'react';

import Text from './Typography';
import { InstitutionAddress } from '../../types/institution';

type Props = {
  address: InstitutionAddress
}

const ProviderAddress = ({ address }: Props) => (
  <div className='providers__address'>
    {address.institution && address.institution.institution_name
      && <Text paragraph bold>{address.institution.institution_name}</Text>}
    {address.address
      && <Text paragraph>{address.address}</Text>}
    {(address.city || address.province)
      && <Text paragraph>{address.city}{address.city && address.province && ', '}{address.province}</Text>}
    {address.postal_code
      && <Text paragraph uppercase>{address.postal_code}</Text>}
  </div>
);

export default ProviderAddress;


// WEBPACK FOOTER //
// ./src/components/shared/ProviderAddress.js